import {PaginationResponse} from '@/api/pagination';

/**
 * Returns the next page number for infinite query pagination.
 * @param lastPage The last page of the query results.
 * @returns The next page number or undefined if there are no more pages.
 */
function getNextPageParam(lastPage: {
  pagination: PaginationResponse;
}): number | undefined {
  const {pagination} = lastPage;
  if (pagination.currentPage < pagination.totalPages) {
    return pagination.currentPage + 1;
  }
  return undefined;
}

export default {
  getNextPageParam,
};
